import { DistributiveOmit } from '@emotion/react';
import * as editor from '@varos/editor-core';
import * as research from '@varos/research-sdk';
import { assertNever } from '@varos/util-typescript';

function buildEditorSuggestionPosition(
    item: research.SuggestionPosition
): editor.SuggestionPosition {
    if (item.kind === 'append') {
        return {
            kind: 'append',
        };
    }
    if (item.kind === 'before') {
        return {
            kind: 'before',
            node: item.anchor,
        };
    }
    if (item.kind === 'after') {
        return {
            kind: 'after',
            node: item.anchor,
        };
    }
    assertNever(item);
}

function buildEditorSuggestionBlock(
    item: research.BlockCreatePayload
): DistributiveOmit<editor.AnyNode, 'id'> {
    if (item.kind === 'text') {
        return {
            kind: 'text',
            content: item.items.map((item): editor.AnySpan => {
                if (item.kind === 'text') {
                    return {
                        kind: 'text',
                        text: item.text,
                        annotations: {
                            bold: false,
                            italic: false,
                            underline: false,
                        },
                        href: null,
                    };
                }
                if (item.kind === 'mention' || item.kind === 'reference') {
                    throw new Error('mention and reference are not supported');
                }
                assertNever(item);
            }),
        };
    }
    if (item.kind === 'callout') {
        return {
            kind: 'callout',
            icon: 'info',
            content: [
                {
                    kind: 'text',
                    text: item.text,
                    annotations: {
                        bold: false,
                        italic: false,
                        underline: false,
                    },
                    href: null,
                },
            ],
        };
    }
    throw new Error('Unsupported block type: ' + item.kind);
    // assertNever(item);
}

function buildEditorSuggestionOperation(
    item: research.SuggestionOperation,
    index: number
): editor.SuggestionOperation {
    if (item.kind === 'create') {
        return {
            id: index.toString(),
            kind: 'insert',
            position: buildEditorSuggestionPosition(item.position),
            node: buildEditorSuggestionBlock(item.block),
        };
    }
    if (item.kind === 'update') {
        return {
            id: index.toString(),
            kind: 'update',
            nodeId: item.id,
            node: buildEditorSuggestionBlock(item.block),
        };
    }
    if (item.kind === 'delete') {
        return {
            id: index.toString(),
            kind: 'delete',
            nodeId: item.id,
        };
    }
    assertNever(item);
}

export function buildEditorSuggestion(
    item: research.SuggestionCreatePayload
): editor.Suggestion {
    console.log('buildEditorSuggestion: input payload:', item);

    const operations = item.operations.map((operation, index) =>
        buildEditorSuggestionOperation(operation, index)
    );
    console.log('buildEditorSuggestion: converted operations:', operations);

    return {
        operations,
    };
}
